let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("krYeu")).then(() => parcelRequire('4fFsO'));